import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    collection: PropTypes.oneOf(['fa', 'yp']),
    icon: PropTypes.string.isRequired,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    collection: 'fa',
    componentClass: 'i',
};

class Icon extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            collection,
            icon,
        } = this.props;
        switch (collection) {
            case 'yp':
                return [
                    'yp_font',
                    `yp_font_${icon}`,
                    className,
                ];
            default:
                return [
                    'fa',
                    `fa-${icon}`,
                    className,
                ];
        }
    }

}

Icon.propTypes = propTypes;

Icon.defaultProps = defaultProps;

export default Icon;
